import { FormContentBlockBody, FormContentBlockHeader, FormContentBlockWrapper } from './styled'

export const FormContentBlock = ({ header, children, nested, half, disabled, style }) => {
    return (
        <FormContentBlockWrapper disabled={disabled} half={half} nested={nested} style={style}>
            <FormContentBlockBody header={header} half={half} nested={nested}>
                {header && <FormContentBlockHeader half={half}>{header}</FormContentBlockHeader>}
                {children}
            </FormContentBlockBody>
        </FormContentBlockWrapper>
    )
}
